export { FaroRoute } from './FaroRoute';
export { initializeReactRouterV4V5Instrumentation } from './initialize';
export { setReactRouterV4V5SSRDependencies } from './routerDependencies';
//# sourceMappingURL=index.js.map